export default "{\n    \"viewOptions\": {\n        \"month\": \"Month\",\n        \"week\": \"Week\",\n        \"day\": \"Day\"\n    }\n}\n"